<template>
  <div class="panel__content__element">
    <div class="g-handle" />
    <accordion-element-component
      class="g-grey-box"
      v-bind="{Data: {icon: ['custom', 'stations'], title: $tc('messages.sharedTexts.stations.station', 1), subTitle: computedRunningStationsTitle}}"
    >
      <mini-stations-element
        v-if="stations.length && computedRunningStations.stations.length > 0"
        :stations="computedRunningStations.stations"
        @stationClicked="goToStation"
      />
      <button
        type="button"
        class="g-btn g-btn--rounded"
        @click.stop="goToStations()"
      >
        {{ this.$t('messages.sharedTexts.stations.goToStations') }}
      </button>
    </accordion-element-component>
  </div>
</template>

<script>
import AccordionElement from '@/components/elements/AccordionElement'
import MiniStationsElement from '@/components/elements/MiniStationsElement'

export default {
  name: 'AccordionStations',
  components: {
    'accordion-element-component': AccordionElement,
    'mini-stations-element': MiniStationsElement
  },
  props: {
    stations: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
    }
  },
  computed: {
    computedDisabled() {
      return this.stations.length ? false : true
    },
    computedRunningStations() {
      let stations = []
      let faulted = 0
      let running = 0

      this.stations.forEach(station => {
        if(station.status === '1') {
          stations.push(station)
          faulted += 1
        } else if(station.isRunning) {
          stations.push(station)
          running += 1
        }
      })
      return {stations, faulted, running}
    },
    computedRunningStationsTitle() {
      let rtnStr = this.$t('messages.sharedTexts.stations.loadingRunning')
      const temp = this.computedRunningStations.running
      ? `<span class="blue">${this.computedRunningStations.running}&nbsp; ${this.$t('messages.sharedTexts.status.running')}</span>`
      : this.computedRunningStations.running + ' ' + this.$t('messages.sharedTexts.status.running')

      if(this.stations.length > 0) rtnStr = `${temp}&nbsp;${this.$t('messages.sharedTexts.outOf')} ${this.stations.length}`
      
      if(this.computedRunningStations.faulted)
        rtnStr += `,&nbsp;<span class="red">${this.computedRunningStations.faulted} ${this.$t('messages.sharedTexts.stations.faulted')}</span>`

      return rtnStr
    }
  },
  methods: {
    goToStations() {
      this.$route.path === '/stations' ? this.$emit('toggleDashboard') : this.$router.push('/stations')
    },
    goToStation(station) {
      this.$router.push('/stations?id=' + station.StId)
    }
  }
}
</script>

<style lang="scss">
  .panel__content__element .accordion-element__title.accordion-element__title--subtitle {
    display: block;
  }
</style>
